import React from 'react';

export const Swoosh = ({ width, height, fill}) => {
  return (
    <div style={{ paddingBottom: '10px' }}>
        <svg
            width={width}
            height={height}
            viewBox="0 0 49 18"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.875 0.613525L13.2225 15.7369C10.2542 16.9962 7.75709 17.6246 5.74479 17.6246C3.48063 17.6246 1.83125 16.8256 0.818336 15.2304C-0.495206 13.1748 0.0789607 9.86248 2.33229 6.36873C3.67021 4.32665 5.37104 2.45248 7.02854 0.659567C6.63854 1.29332 3.19625 7.02144 6.96084 9.71894C7.70563 10.2606 8.76459 10.526 10.0673 10.526C11.1127 10.526 12.3125 10.3554 13.6315 10.0114L48.875 0.613525Z"
                fill={fill}
            />
        </svg>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/assets/Swoosh.js